import "./App.css";
import "./styles/style.css";
import "semantic-ui-css/semantic.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Navbar from "./components/Navbar";
import Photos from "./components/Photos";
import Videos from "./components/Videos";
import Main from "./components/Main";

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Switch>
          <Route path="/" exact component={Main} />
          <Route path="/photos" exact component={Photos} />
          <Route path="/videos" exact component={Videos} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
